import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Chip,
  Button,
  Stack,
} from "@mui/material";
import { IoPersonCircleOutline } from "react-icons/io5";
import { FaRegMessage, FaUser } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import MessageIconWithCount from "./MessageIconWithCount";
import { IoShareSocial } from "react-icons/io5";
import SharePopup from "./SharePopup.jsx";

const BlogCard = ({ card_id, title, tags, card_image, category }) => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const slugify = (title) =>
    title
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "");

  const handleClick = (index, title) => {
    console.log("cardInfo:", index, title);
    const slug = slugify(title);
    navigate(`/blog-content/${slug}`, { state: { index } });
  };

  return (
    <Card
      sx={{
        width: "100%",
        height: "100%",
        borderRadius: "20px 0",
        boxShadow: 3,
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
        "&:hover": {
          transform: "translateY(-8px)",
          boxShadow: 6,
        },
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* <CardMedia
        component="img"
        height="180"
        image={card_image}
        alt={title}
      /> */}

      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "160px",
          overflow: "hidden",
          cursor: "pointer",
          // border: "2px solid red",
        }}
      >
        {/* Image */}
        <Box
          component="img"
          src={card_image}
          alt="Webinar Image"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />

        {/* Transparent Black Overlay */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "black",
            opacity: isHovered ? 0.2 : 0,
            transition: "opacity 0.3s ease-in-out",
            pointerEvents: "none",
          }}
        />

        <Box
          sx={{
            position: "absolute",
            top: "16px",
            right: "-48px",
            backgroundColor: "#f97316",
            color: "white",
            fontWeight: "bold",
            fontSize: "10px",
            padding: "2px 45px",
            transform: "rotate(45deg)",
            zIndex: 3,
            textTransform: "uppercase",
            boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
          }}
        >
          Upcoming
        </Box>

        {/* Animated Dots */}
        {isHovered && (
          <Stack
            direction="row"
            spacing={1}
            sx={{
              position: "absolute",
              top: "50%",
              left: "0%",
              transform: "translateY(-50%)",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            {/* Dot 1 */}
            <Box
              sx={{
                width: "10px",
                height: "10px",
                backgroundColor: "white",
                borderRadius: "50%",
                animation: "moveToCenter 0.5s ease-in-out forwards 0s", // First dot animation
              }}
            />
            {/* Dot 2 */}
            <Box
              sx={{
                width: "10px",
                height: "10px",
                backgroundColor: "white",
                borderRadius: "50%",
                animation: "moveToCenter 0.3s ease-in-out forwards 0.0s", // Second dot with delay
              }}
            />
            {/* Dot 3 */}
            <Box
              sx={{
                width: "10px",
                height: "10px",
                backgroundColor: "white",
                borderRadius: "50%",
                animation: "moveToCenter 0.1s ease-in-out forwards 0.0s", // Third dot with delay
              }}
            />
          </Stack>
        )}

        {/* Keyframes for animation */}
        <style>
          {`
          @keyframes moveToCenter {
            from {
              transform: translateX(-200%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
        `}
        </style>
      </Box>

      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          component="div"
          sx={{
            // border: "1px solid red",
            fontSize: "16px",
            fontWeight: 550,
            color: "#666",
            lineHeight: 1.3
          }}
          gutterBottom
        >
          {title}
        </Typography>

        <Box sx={{ mt: 1, display: "flex", gap: 1, flexWrap: "wrap" }}>
          {tags.map((tag, i) => (
            <Chip
              key={i}
              label={tag}
              size="small"
              sx={{
                // border: "1px solid red",
                fontSize: "0.90rem",
                background: "#f1f1f1",
                color: "text.secondary",
                fontWeight: "400",
                fontFamily: "'Roboto', sans-serif",
                mb: 2,
              }}
            />
          ))}
        </Box>

        <Button
          size="small"
          endIcon={<span>&#10132;</span>}
          sx={{ textTransform: "none", fontWeight: 600}}
          onClick={() => handleClick(card_id - 1, title)}
        >
          Read More
        </Button>

        <Typography
          sx={{
            color: "text.secondary",
            mt: 2,
            display: "flex",
            justifyContent: "space-between",
            fontSize: "14px",
            alignItems: "center",
          }}
        >
          <Stack
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: "2px",
              alignItems: "center",
            }}
          >
            <IoPersonCircleOutline size={18} />
            <span>Vertex Suite</span>
          </Stack>
          <IoShareSocial size={18} />
        </Typography>
      </CardContent>
    </Card>
  );
};

export default BlogCard;
